/**
 * card-product-custom.js
 *
 * 1. Variant swatch hover → swap imagen principal
 * 2. ATC con AJAX — abre el cart drawer igual que el tema nativo
 */

(function () {
  'use strict';

  // ── 1. SWATCHES ─────────────────────────────────────────────────────────────
  function initCardSwatches(root) {
    root.querySelectorAll('.card-product__swatches').forEach(function (container) {
      const cardWrapper = container.closest('.card-wrapper');
      const img = cardWrapper ? cardWrapper.querySelector('.card-product__main-image') : null;
      if (!img) return;

      const defaultSrc    = img.dataset.defaultSrc || img.getAttribute('src');
      const defaultSrcset = img.getAttribute('srcset');

      container.querySelectorAll('.card-product__swatch').forEach(function (swatch) {
        swatch.addEventListener('mouseenter', function () {
          const variantSrc = swatch.dataset.variantImage;
          if (!variantSrc) return;
          img.removeAttribute('srcset');
          img.src = variantSrc;
        });

        swatch.addEventListener('mouseleave', function () {
          img.src = defaultSrc;
          if (defaultSrcset) img.setAttribute('srcset', defaultSrcset);
        });

        swatch.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      });
    });
  }

  // ── 2. ADD TO CART ───────────────────────────────────────────────────────────
  function initCardATC(root) {
    root.querySelectorAll('.js-card-atc').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const variantId = btn.dataset.variantId;
        if (!variantId || btn.disabled) return;

        const originalHTML = btn.innerHTML;
        btn.disabled = true;
        btn.classList.add('is-loading');
        btn.innerHTML = '...';

        // Pedimos el re-render del cart-drawer igual que hace el tema
        const body = JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        });

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript',
          },
          body,
        })
          .then(function (r) { return r.json(); })
          .then(function (parsedState) {

            // Error de Shopify (ej: agotado)
            if (parsedState.status) {
              showError(btn, parsedState.description || 'Error', originalHTML);
              return;
            }

            // ── Abrir el drawer exactamente como lo hace el tema ──────────
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(parsedState);
              // Remover is-empty del elemento raíz que el tema no limpia
              cartDrawer.classList.remove('is-empty');
            } else {
              // Fallback: actualizar secciones manualmente si no hay drawer
              updateSections(parsedState);
            }

            // Notificar al resto del tema (burbuja del ícono, etc.)
            if (window.publish && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'card-product-atc',
                cartData: parsedState,
                variantId: variantId,
              });
            }

            // Feedback visual — mostrar ✓ y luego restaurar el SVG original
            btn.innerHTML = '✓';
            setTimeout(function () {
              btn.innerHTML = originalHTML;
              btn.disabled = false;
              btn.classList.remove('is-loading');
            }, 1500);
          })
          .catch(function (err) {
            console.error('[card-product] ATC error:', err);
            showError(btn, 'Error', originalHTML);
          });
      });
    });
  }

  function updateSections(parsedState) {
    if (!parsedState.sections) return;

    // Actualizar ícono del carrito
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && parsedState.sections['cart-icon-bubble']) {
      const html = new DOMParser().parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');
      const newContent = html.querySelector('.shopify-section');
      if (newContent) cartIconBubble.innerHTML = newContent.innerHTML;
    }
  }

  function showError(btn, message, originalHTML) {
    btn.innerHTML = message;
    btn.classList.remove('is-loading');
    setTimeout(function () {
      btn.innerHTML = originalHTML;
      btn.disabled = false;
    }, 2500);
  }

  // ── INIT ─────────────────────────────────────────────────────────────────────
  function init(root) {
    initCardSwatches(root || document);
    initCardATC(root || document);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.CardProductCustom = { init: init };

})();